export default "__VITE_ASSET__Cektp8hR__"